import Vue from 'vue';
import './plugins/vuetify';
import {auth} from './fbConfig';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

let app;
auth.onAuthStateChanged(user => {
  if (!app) {
    store.commit('setIsAuthenticated', user != null);

    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
